import _ from "lodash";
import { FC } from "react";
import { useMatches } from "react-location";
import AppLayout from "./app";
import AuthLayout from "./auth";
import _404Layout from "./_404";
import OnBordingLayout from "./onboard";
import SetupLayout from "./setup";

const LayoutProvider: FC = () => {
  const matches = useMatches();
  const meta = _.last(matches)?.route?.meta;

  switch (meta?.layout) {
    case "App": {
      return <AppLayout />;
    }
    case "Auth": {
      return <AuthLayout />;
    }
    case "Onboarding": {
      return <OnBordingLayout />;
    }
    case "Setup": {
      return <SetupLayout />;
    }
    default: {
      return <_404Layout />;
    }
  }
};

export default LayoutProvider;
